import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMedia } from 'modules/common/hooks/useMedia';

import { ModalTemplate } from 'components/ModalTemplate';
import { ModalTemplateSettings } from 'components/ModalTemplate/types';
import { ScTemplateEmailContent } from './styled';
import { Button } from 'components/buttons';

interface ITemplateEmailForNDBModal {
  img: string;
  link?: string;
  ref: React.ForwardedRef<HTMLDivElement>;
  onClose?: () => void;
}

export const TemplateEmailForNDBModal: FC<ITemplateEmailForNDBModal> = ({
  onClose,
  img,
  link,
  ref,
}) => {
  const { t } = useTranslation('emailNDBModal');

  const text = link ? 'confirmed' : 'confirm';

  const { isMobileS } = useMedia();

  const handleClick = useMemo(() => {
    if (link) {
      return {
        to: link,
        onLinkClick: onClose,
      };
    }
    return { onClick: onClose };
  }, [link, onClose]);

  const templateSettings: ModalTemplateSettings = useMemo(
    () =>
      isMobileS
        ? {
            type: 'mobile',
            mode: {
              type: 'default',
            },
          }
        : {
            type: 'desktop',
            size: 'small',
            mode: {
              type: 'default',
            },
          },
    [isMobileS]
  );

  return (
    <ModalTemplate ref={ref} onClose={onClose} settings={templateSettings}>
      <ScTemplateEmailContent>
        <img src={img} alt="email confirmation" className="img" />

        <p className="title">{t(`${text}.title`)}</p>
        <p className="description">{t(`${text}.description`)}</p>

        <Button green xLarge {...handleClick}>
          {t(`${text}.button`)}
        </Button>
      </ScTemplateEmailContent>
    </ModalTemplate>
  );
};
